module.exports = __webpack_public_path__ + "img/立即参与秒杀.41e3bf92.png";